/**
 * constants/index.js
 * Re-exports all constants for convenient importing.
 */

export * from '../../../shared/src/calculation/constants/ratesAndThresholds.ts';
export { AGED_CARE_SCHEDULE } from '../../../shared/src/calculation/constants/agedCareSchedule.ts';
export { ACAT_LEVEL_DATA } from '../../../shared/src/calculation/constants/acatLevelData.ts';
import { ASSET_TYPES as ASSET_TYPES_DATA, LIABILITY_TYPES as LIABILITY_TYPES_DATA } from '../../../shared/src/calculation/constants/assetTypes.ts';
import { ASSET_TYPE_ICONS, LIABILITY_TYPE_ICONS } from './assetTypeIcons.ts';
// The shared module is data-only (no lucide-react); attach each type's UI icon here for
// components (e.g. ClientProfileSteps.js's Assets/Liabilities step legends) that display one.
export const ASSET_TYPES = ASSET_TYPES_DATA.map((type) => ({ ...type, icon: ASSET_TYPE_ICONS[type.id] }));
export const LIABILITY_TYPES = LIABILITY_TYPES_DATA.map((type) => ({ ...type, icon: LIABILITY_TYPE_ICONS[type.id] }));
export { INITIAL_FACT_FIND } from './initialFactFind.ts';
/**
 * How many years the aged care projection runs for until the reader changes it (the "Project Legacy
 * Over" field on the Financial Impact panel). Seeds App's `legacyYears`, and stands in wherever that
 * value arrives missing or zero, so every consumer starts on the same horizon.
 *
 * Owner's call, 2026-08-06: back to 5 (it was raised to 10 on 2026-07-29). Every "Legacy Estimate" in
 * the module is the estate at the END of this horizon, so changing it re-bases all of them and can
 * change which strategy the Suggestion Engine ranks as optimal — the winner is chosen on the estate
 * at the horizon, and a longer run favours different funding. The year-1 figures (cashflow, age
 * pension, the daily cost breakdown) are unaffected.
 */
export const DEFAULT_PROJECTION_YEARS = 5;
export {
    GOAL_INSIGHTS,
    FAMILY_ESTATE_INSIGHTS,
    DEFICIT_CONTEXT_FRAMING_COPY,
    INSIGHT_COMPARISON_YR1_LABEL,
} from './insightsConfig.ts';
export {
    STEP4_FIELD_TOOLTIPS,
    buildStep4InsightSections,
    formatGoalList,
    getSelectedLivingGoals,
} from './step4LivingInsightKnowledge.ts';
export { ASFA_BUDGET } from '../../../shared/src/calculation/constants/asfaBudget.ts';
export {
    RETIREMENT_VILLAGE_STATES,
    RETIREMENT_VILLAGE_STATE_RULES,
    getRetirementVillageStateRules,
} from '../../../shared/src/calculation/constants/retirementVillageStateRules.ts';
